<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import 'typeface-montserrat';

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
*{
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
}

.print-table td,
.print-table th,
.print-table tr {
    border: 1px solid rgb(0, 0, 0);
}
</style>
